import axios from '../axios'
import qs from 'qs';

/* 
 * 组管理模块
 */

// 查询
export const list = (data) => {
	data = qs.stringify(data);
	return axios({
		url: '/kz/group/list',
		method: 'post',
		data
	})
}



// WEBPACK FOOTER //
// ./src/http/moudules/group.js